module.exports = __webpack_public_path__ + "res/Roboto-ThinItalic-webfont.svg?0a9a1ada4ecf31c64bec12f528d91415";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-ThinItalic-webfont.svg
// module id = 60
// module chunks = 0